import ListProducts from '../../Components/ListProducts';

export default function Dashboard() {
  return <ListProducts />;
}
